/**
 * Boards of area (c) — operations. OWNED BY area (c) — operations (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const operationsBoards: BoardDef[] = [
  {
    id: "Admin-Transactions",
    ref: "137",
    title: "Cabinet compta — Transactions",
    area: "operations",
    path: "/compta/transactions",
    href: "/compta/transactions",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.transactions",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Transactions")),
  },
  {
    id: "Admin-Transactions-Detail",
    ref: "138",
    title: "Cabinet compta — Transactions — Atelier Roux",
    area: "operations",
    path: "/compta/transactions/$companyId",
    href: "/compta/transactions/cmp_atelier_roux",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.transactions",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Transactions-Detail")),
  },
  {
    id: "Admin-Transactions-PJ",
    ref: "138b",
    title: "Cabinet compta — Voir la pièce jointe",
    area: "operations",
    path: "/compta/transactions/$companyId",
    href: "/compta/transactions/cmp_atelier_roux?fenetre=piece&transaction=tx_demo",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "window",
    nav: "compta.transactions",
    space: "compta",
    note: "tx_demo = l'opération Leroy Merlin (trx_leroy) d'Atelier Roux.",
    component: lazy(() => import("./boards/Admin-Transactions-PJ")),
  },
  {
    id: "Admin-Transactions-Invalider",
    ref: "139",
    title: "Cabinet compta — Demander une nouvelle pièce",
    area: "operations",
    path: "/compta/transactions/$companyId",
    href: "/compta/transactions/cmp_atelier_roux?fenetre=invalider&transaction=tx_demo",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "window",
    nav: "compta.transactions",
    space: "compta",
    note: "tx_demo = Leroy Merlin (trx_leroy). « Demander » : ?fenetre=demander&transaction=trx_ovh.",
    component: lazy(() => import("./boards/Admin-Transactions-Invalider")),
  },
  {
    id: "Admin-Impots",
    ref: "140",
    title: "Cabinet compta — Impôts et taxes",
    area: "operations",
    path: "/compta/impots",
    href: "/compta/impots",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.impots",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Impots")),
  },
  {
    id: "Admin-Impots-TVA",
    ref: "141",
    title: "Cabinet compta — Traiter la TVA — Luminex",
    area: "operations",
    path: "/compta/impots/$companyId/$tax",
    href: "/compta/impots/cmp_luminex/tva",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.impots",
    space: "compta",
    note: "Ouvre la TVA de septembre de Luminex (tableur du board) ; ?declaration= choisit une autre période.",
    component: lazy(() => import("./boards/Admin-Impots-TVA")),
  },
  {
    id: "Admin-Impots-IS",
    ref: "142",
    title: "Cabinet compta — Acompte IS — Aether",
    area: "operations",
    path: "/compta/impots/$companyId/$tax",
    href: "/compta/impots/cmp_aether/is",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.impots",
    space: "compta",
    note: "Acompte déc. 2026 d'Aether.",
    component: lazy(() => import("./boards/Admin-Impots-IS")),
  },
  {
    id: "Admin-Impots-CFE",
    ref: "143",
    title: "Cabinet compta — CFE — Atelier Roux",
    area: "operations",
    path: "/compta/impots/$companyId/$tax",
    href: "/compta/impots/cmp_atelier_roux/cfe",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.impots",
    space: "compta",
    note: "CFE 2026 d'Atelier Roux, avis déjà attaché (brouillon dans Documents › Fiscal).",
    component: lazy(() => import("./boards/Admin-Impots-CFE")),
  },
  {
    id: "Admin-Impots-TVS",
    ref: "143b",
    title: "Cabinet compta — Taxe véhicule société — Atelier Roux",
    area: "operations",
    path: "/compta/impots/$companyId/$tax",
    href: "/compta/impots/cmp_atelier_roux/tvs",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.impots",
    space: "compta",
    note: "TVS 2026 d'Atelier Roux, sans PDF : « Publier au client » grisé.",
    component: lazy(() => import("./boards/Admin-Impots-TVS")),
  },
  {
    id: "Admin-Documents",
    ref: "144",
    title: "Cabinet compta — Documents",
    area: "operations",
    path: "/compta/documents",
    href: "/compta/documents",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.documents",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Documents")),
  },
  {
    id: "Admin-Social",
    ref: "146",
    title: "Cabinet compta — Social",
    area: "operations",
    path: "/compta/social",
    href: "/compta/social",
    permission: ["cabinet.operations", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.social",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Social")),
  },
];
